export const NAMESPACE = "@seriously-rad/seriouslyrad-framework-module-integrations/";